import type { EmbeddedUser } from 'modules/core/types';
import { ReactElement } from 'react';
import { TitleContainer } from './TitleContainer';
import { getUserTitle } from 'modules/core/helpers';

export function UserTitle({ flat, ...user }: EmbeddedUser & { flat?: boolean }): ReactElement {
  return <TitleContainer title={getUserTitle(user)} subtitle={user.email} flat={flat} />;
}
